import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Result, Radio, Tag, Space, Grid } from 'antd';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XThemeTag2,
	XEditButtonIcon,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeFilterCircleButton,
	XThemeRadio,
} from '../../styles/GlobalThemeStyle';
import { dateFilters } from '../../utils/constants';
import DataTable from '../../components/DataTable/DataTable';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';

import moment from 'moment';
import CaseSearch from '../../components/CaseSearch/CaseSearch';

import { checkModulePermissions, urlPagination } from '../../utils/helper';
import { getModuleByIdApi } from '../../actions/getModuleByIdAction';
import {
	getModulesListApi,
	getModulesListReset,
} from '../../actions/getModulesListAction';
import { editModuleApi } from '../../actions/editModuleAction';
import { addModuleApi } from '../../actions/addModuleAction';
import {
	deleteModuleApi,
	deleteModuleReset,
} from '../../actions/deleteModuleAction';
import { XTheme2InnerCard } from '../Dashboard/DashboardStyleCQ';
import {
	XTheme2Button,
	XTheme2InputText,
} from '../../styles/GlobalThemeStyleCQ';

const AdminConfigurations = (props) => {
	const {
		getModulesListState,
		deleteModuleState,
		getModulesList,
		deleteModuleReset,
	} = props;
	let modulePermissions = checkModulePermissions('module-management');
	const navigate = useNavigate();
	const defaultFilters = {
		search: '',
		page: 1,
		sort: 'updatedAt',
		sortDirection: 'descend',
		created_on: 'all',
		limit: 10,
	};
	const [tableData, setTableData] = useState([]);
	const [totalRecords, setTotalRecords] = useState('');

	const [form2] = XThemeForm.useForm();

	const [open, setOpen] = useState(false);
	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);

	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
	};

	const onChange = (key) => {
		setFilters({
			...filters,
			[key.target.name]: key.target.value,
		});
	};

	const columns = [
		{
			title: 'Module Name',
			width: 200,
			dataIndex: 'module_name',
			fixed: 'left',
			render: (module_name) => (
				<div>
					<div>{module_name}</div>
				</div>
			),
		},
		{
			title: 'Sub Modules',
			// width: 200,
			dataIndex: 'sub_modules',
			render: (sub_modules) => (
				<div>
					<div>{sub_modules}</div>
				</div>
			),
		},
		{
			title: 'Created On',
			width: 150,
			dataIndex: 'createdAt',
			sorter: (a, b) => a.createdAt - b.createdAt,
			sortDirections: ['ascend', 'descend'],
			render: (createdAt) => (
				<div>
					<div>{createdAt}</div>
				</div>
			),
		},
		{
			title: 'Action',
			width: 100,
			dataIndex: 'action',
			fixed: 'right',
		},
	];

	// use effects

	useEffect(() => {
		if (getModulesListState.apiState === 'success') {
			if (getModulesListState.data.modules.length > 0) {
				const updatedData = [];
				const updatedSearchOptions = [];
				setTotalRecords(getModulesListState.data.total_count);
				getModulesListState.data.modules.map((item, index) => {
					updatedSearchOptions.push({ value: item.name });
					updatedData.push({
						key: item._id,
						_id: item._id,
						module_name: item.module_name,
						sub_modules: item.sub_modules.map((ele) => (
							<XThemeTag2>{ele.sub_module_name}</XThemeTag2>
						)),
						createdAt: (
							<div className="showDate">
								{moment(item.createdAt).format('DD-MM-YYYY')}
							</div>
						),
						action: (
							<div className="text-center">
								{item.module_slug === 'module-management' ? (
									<></>
								) : (
									<>
										{modulePermissions.sub_modules.includes(
											'update-module',
										) ? (
											<XEditButtonIcon
												onClick={() =>
													navigate(
														`/module/edit/${item._id}`,
													)
												}
												type="text"
											>
												<img
													src="./images/pencil.svg"
													alt=""
												/>
											</XEditButtonIcon>
										) : (
											<></>
										)}
									</>
								)}
							</div>
						),
					});
				});
				setTableData(updatedData);
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
		}
	}, [getModulesListState]);

	useEffect(() => {
		if (deleteModuleState.apiState === 'success') {
			deleteModuleReset();
			getModulesList();
		}
	}, [deleteModuleState]);

	const applyFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through filters and update the query parameters
		Object.entries(filters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the current value
				queryParams.append(key, value);
			}
		});

		// Set the page to 1
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');
		filters.page = 1;

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	useEffect(() => {
		// Retrieve filters from the updated URL
		const updatedFilters = getFiltersFromUrl();
		setFilters({ ...updatedFilters });
		// Make API call with updated filters and pagination
		checkModulePermissions('module-management').sub_modules.includes(
			'list-modules',
		) && getModulesList({ ...updatedFilters });
	}, [window.location.search]);

	const clearFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through defaultFilters and update the query parameters
		Object.entries(defaultFilters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the default value
				queryParams.append(key, value);
			}
		});

		// Clear the form fields
		form2.resetFields();

		// Update the state with default values
		setFilters(defaultFilters);

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			{modulePermissions.authorized ? (
				<>
					<XTheme2InnerCard
						className="mb-3"
						bodyStyle={{ padding: '20px 0px' }}
					>
						<div className="smallTopBottomPadding mb-3 px-4">
							<CaseSearch
								filters={[
									<XThemeForm.Item
										name="created_on"
										colon={false}
										label="Date Within"
										className="drawerlabel"
									>
										<XThemeRadio.Group
											onChange={onChange}
											name="created_on"
										>
											<Row>
												{dateFilters.map(
													(item, index) => (
														<Col
															xs={12}
															lg={12}
															md={12}
															xl={12}
														>
															<XThemeRadio
																value={
																	item.value
																}
															>
																{item.label}
															</XThemeRadio>
														</Col>
													),
												)}
											</Row>
										</XThemeRadio.Group>
									</XThemeForm.Item>,
								]}
								onClose={onClose}
								open={open}
								applyFilters={applyFilters}
								form={form2}
								clearFilters={clearFilters}
							/>
							<Row
								gutter={(15, 15)}
								className="align-items-center"
							>
								<Col xs={16} sm={14} md={6} lg={4}>
									<h1
										className="cardTitle mb-0"
										style={{ fontSize: '18px' }}
									>
										Total {totalRecords} Modules
									</h1>
								</Col>
								<Col
									xs={24}
									sm={16}
									md={12}
									lg={12}
									className="d-none d-md-block"
								>
									<Space>
										<XTheme2InputText
											size="large"
											allowClear
											placeholder="Search for Modules"
											defaultValue={
												filters.search
													? filters.search
													: null
											}
											onChange={(v) => {
												if (v.target.value === '') {
													urlPagination(
														filters,
														'search',
														'',
													);
													setFilters({
														...filters,
														search: '',
													});
												} else {
													setFilters({
														...filters,
														search: v.target.value,
													});
												}
											}}
											onKeyDown={(e) => {
												if (e.key === 'Enter') {
													const searchValue =
														filters.search
															? filters.search
															: '';
													if (searchValue) {
														urlPagination(
															filters,
															'search',
															searchValue,
														);
														setFilters({
															...filters,
															search: searchValue,
														});
													}
												}
											}}
										/>
										<XTheme2Button
											onClick={() => {
												// Trigger search when the button is clicked
												const searchValue =
													filters.search
														? filters.search
														: '';
												if (searchValue) {
													urlPagination(
														filters,
														'search',
														searchValue,
													);
													setFilters({
														...filters,
														search: searchValue,
													});
												}
											}}
											className="px-4"
											size="large"
										>
											Search
										</XTheme2Button>
									</Space>
									{/* <XThemeForm.Item>
								<XSearch
									placeholder="Search for Modules"
									allowClear
									enterButton="Search"
									size="large"
									onChange={(v) => {
										if (v === '') {
											urlPagination(
												filters,
												'search',
												'',
											);
											setFilters({
												...filters,
												search: '',
											});
										}
									}}
									onSearch={(v) => {
										setFilters({
											...filters,
											search: v,
										});
										getModulesList({
											...filters,
											search: v,
										});
									}}
								/>
							</XThemeForm.Item> */}
								</Col>
								<Col
									xs={8}
									sm={10}
									md={6}
									lg={8}
									className="text-end"
								>
									<Space>
										<XTheme2Button
											className="noBackground borderColor"
											shape="circle"
											size="large"
											onClick={() => showDrawer()}
											icon={
												<img
													src="/images/theme-filter-icon.svg"
													alt="filter"
												/>
											}
										/>
										{modulePermissions.sub_modules.includes(
											'add-module',
										) ? (
											isMobile ? (
												<XTheme2Button
													shape="circle"
													size="large"
													className="noBackground borderColor"
													onClick={() =>
														navigate('/module/add')
													}
													icon={<PlusOutlined />}
												/>
											) : (
												<XTheme2Button
													size="large"
													onClick={() =>
														navigate('/module/add')
													}
													icon={<PlusOutlined />}
												>
													Add Module
												</XTheme2Button>
											)
										) : (
											<></>
										)}
									</Space>
								</Col>
							</Row>
						</div>

						<DataTable
							tableData={tableData}
							columns={columns}
							totalRecords={totalRecords}
							setFilters={setFilters}
							filters={filters}
							state={getModulesListState.apiState}
							page={'module'}
						/>
					</XTheme2InnerCard>
				</>
			) : (
				<Result
					status="403"
					title="403"
					subTitle="Sorry, you are not authorized to access this page."
					extra={
						<Button type="primary" onClick={() => navigate('/')}>
							Back Home
						</Button>
					}
				/>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	getModuleByIdState: state.getModuleById,
	getModulesListState: state.getModulesList,
	editModuleState: state.editModule,
	addModuleState: state.addModule,
	deleteModuleState: state.deleteModule,
});

const mapDispatchToProps = (dispatch) => ({
	getModuleById: (params) => dispatch(getModuleByIdApi(params)),
	getModulesList: (params) => dispatch(getModulesListApi(params)),
	editModule: (params) => dispatch(editModuleApi(params)),
	addModule: (params) => dispatch(addModuleApi(params)),
	deleteModule: (params) => dispatch(deleteModuleApi(params)),
	getModulesListReset: (params) => dispatch(getModulesListReset(params)),
	deleteModuleReset: (params) => dispatch(deleteModuleReset(params)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(AdminConfigurations);
